<div
  class="login-shell md:relative md:mb-2 max-md:pt-16 md:overflow-hidden md:rounded-2xl bg-white md:shadow transition-all min-h-[430px] w-full md:w-[420px] max-w-96 md:max-w-[calc(100vw-2rem)] max-md:px-3 p-7"
>
  <div class="route-body">
    <app-header class="w-full"></app-header>

    <div
      class="h-full w-full min-h-32"
      [ngClass]="{ 'opacity-50 pointer-events-none select-none cursor-wait': loginLoading$ | async }"
    >
      <router-outlet></router-outlet>
    </div>
    @if (loginLoading$ | async) {
      <ion-progress-bar
        type="indeterminate"
        class="max-md:w-screen absolute left-0 max-md:mt-6 md:bottom-0 progress-fade-in"
      >
      </ion-progress-bar>
    }
  </div>
</div>
